import React from "react";
import { Paper, IconButton, Stack } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { MonthPicker } from "../index";

export const MonthFilter = ({
  value,
  onChange,
  sx = {},
  width = 250,
  futureDisabled = false,
}) => {
  const handleIncrementDecrementDate = (direction) => {
    const newDate = new Date(value);
    if (direction === "left") {
      newDate.setMonth(newDate.getMonth() - 1);
    } else {
      newDate.setMonth(newDate.getMonth() + 1);
    }
    onChange(newDate);
  };

  const isCurrentOrFutureMonth = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const selectedMonth = value.getMonth();
    const selectedYear = value.getFullYear();

    return (
      selectedYear > currentYear ||
      (selectedYear === currentYear && selectedMonth >= currentMonth)
    );
  };

  return (
    <Paper
      sx={{
        padding: "4px 12px 9px 12px",
        height: "40px",
        width: `${width}px`,
        boxShadow: "0px 4px 4px rgba(48, 111, 188, 0.2)",
        borderRadius: "8px",
        ...sx,
      }}
      elevation={2}
    >
      <Stack direction="row">
        <IconButton
          onClick={() => handleIncrementDecrementDate("left")}
          size="small"
        >
          <ArrowBackIosNew
            sx={{ fontSize: "14px", color: "rgb(48,111,188)" }}
          />
        </IconButton>
        <MonthPicker
          value={value}
          onChange={onChange}
          disableFutureMonths={futureDisabled}
        />
        <IconButton
          onClick={() => handleIncrementDecrementDate("right")}
          size="small"
          disabled={futureDisabled && isCurrentOrFutureMonth()}
        >
          <ArrowForwardIos
            style={{
              fontSize: "14px",
              color:
                futureDisabled && isCurrentOrFutureMonth()
                  ? "rgba(48, 111, 188, 0.3)"
                  : "rgb(48,111,188)",
            }}
          />
        </IconButton>
      </Stack>
    </Paper>
  );
};
